var API_DOMAIN = "https://srivigneshwarafinance.zentexus.com/api";

export default API_DOMAIN;
